enum LeadSource {
  CONTACT_FORM = 'CONTACT_FORM',
  ONBOARDING = 'ONBOARDING',
}

export default LeadSource
